import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Dropdown from 'react-bootstrap/Dropdown';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { useRootStore } from '../../../loaders/useRootStore';
import { ClaimType } from '@yakoffice/publisher-types';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Form } from 'react-bootstrap';

interface PropsType {
  [key: string]: any,

  selectedGameVersions: IGameVersion[],
  handleGameVersionSelected?: (gameVersion: IGameVersion) => void,
  handleGameVersionUnselected?: (gameVersion: IGameVersion) => void,
}

export const GameVersionMultiSelector: FC<PropsType> = observer(({
                                                                   selectedGameVersions,
                                                                   handleGameVersionSelected,
                                                                   handleGameVersionUnselected,
                                                                   ...props
                                                                 }) => {
  const rootStore = useRootStore();

  const handleToggleGameVersion = (gameVersion: IGameVersion) => {
    selectedGameVersions.find(gv => gv === gameVersion)
      ? handleGameVersionUnselected && handleGameVersionUnselected(gameVersion)
      : handleGameVersionSelected && handleGameVersionSelected(gameVersion);
  };

  return rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.ViewAllGameVersions)
    ? <DropdownButton {...props} autoClose={false} data-testid={'ddlGameVersionMultiSelector'} variant="outline-primary"
                      title={`Select Version(s): ${selectedGameVersions.length}`}>
      <React.Fragment>
        {rootStore.gameVersionStore.gameVersions
          .filter(gv => !gv.isArchived())
          .map(gameVersion => {
            return <Dropdown.Item key={gameVersion.id}
                                  as="button">
              <Form.Check
                type={'checkbox'}
                id={gameVersion.id.toString()}
                label={gameVersion.name}
                onClick={() => handleToggleGameVersion(gameVersion)}
                data-testid={`gameVersionMultiSelectorButton${gameVersion.name}`}
              />
            </Dropdown.Item>;
          })}
      </React.Fragment>
    </DropdownButton>
    : null;
});

